<template>
	<div class="input-container">
		<span class="input-label">{{ label }}</span>
		<input type="number" v-model="inputNumber" 
					:placeholder="placeholder" :class="['input-field', {'has-error': hasError}]"
					step="1" @keypress="preventDecimal"
					ref="inputRef" />
	</div>
	<!-- Error message -->
	<span v-if="hasError" class="error-message">{{ errorMessage }}</span>
</template>

<script setup lang="ts">
import { ref, watch, defineEmits, defineProps } from 'vue';

const emit = defineEmits(['updateNumber', 'update:modelValue']);

const props = defineProps({
	placeholder: {
		type: String,
		default: 'Escribe aquí...',
	},
	modelValue: {
		type: Number,
		default: null,
	},
	label: {
		type: String,
		default: 'Label',
	},
	id: {
		type: String,
	},
	hasError: {
		type: Boolean,
		default: false,
	},
	errorMessage: {
		type: String,
		default: '',
	},
	allowDecimals: {
		type: Boolean,
		default: true
	}
});

const inputNumber = ref<number>(props.modelValue);

const preventDecimal = (e: KeyboardEvent) => {
	if(props.allowDecimals==false){
			if (e.key === '.' || e.key === ',') {
			e.preventDefault();
		}
} 
	
};

watch(inputNumber, (newValue: number) => {
	if (inputNumber.value >= 0) {
		emit('updateNumber', props.id, newValue);
		emit('update:modelValue', newValue);
	}
});

watch(
		() => props.modelValue,
		(newValue) => {
			inputNumber.value = newValue;
		},
		{ immediate: true }
);
</script>

<style lang="scss" scoped>
@import 'InputNumberComponent';
</style>